import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { BaseAttributeSelector } from '../BaseAttributeSelector';
import { isInView, scrollToElement } from './horizontalScroll';
import { StyledScrolledAttributeItem } from './styles';
const dataKey = 'data-scroll-item-key';
export const ScrolledAttributeItem = ({ itemKey, ...rest }) => {
    return _jsx(StyledScrolledAttributeItem, { ...rest, [dataKey]: itemKey });
};
export const ScrolledAttributeSelector = ({ formLabel, disableMobileHorizontalSwipe, scrollToItem, ...rest }) => {
    const scrollContainerRef = React.useRef(null);
    React.useEffect(() => {
        if (!scrollToItem)
            return;
        const scrollContainerElement = scrollContainerRef.current;
        const itemElement = scrollContainerElement?.querySelector(`div[${dataKey}='${scrollToItem}']`);
        if (!itemElement)
            return;
        const elements = {
            scrollContainer: scrollContainerElement,
            target: itemElement,
        };
        if (!isInView(elements))
            scrollToElement(elements);
    }, [scrollToItem]);
    return (_jsx(BaseAttributeSelector, { disableMobileHorizontalSwipe: disableMobileHorizontalSwipe, ref: scrollContainerRef, formLabel: formLabel, ...rest }));
};
//# sourceMappingURL=ScrolledAttributeSelector.js.map